export default function uploadPlacesImageFactory(ajax) {
  return async function uploadPlacesImage({ id, img, url, onUploadProgress }) {
    return ajax({
      resource: `places/localities/${id}/${url}`,
      method: 'put',
      data: img.file,
      onUploadProgress,
    });
  };
}



// WEBPACK FOOTER //
// ./src/services/uploadPlacesImage.js